import React, { FC } from "react";
import { Pressable, Text } from "native-base";
import { Video } from "expo-av";
import { ResizeMode } from "expo-av";
import { Ionicons } from "@expo/vector-icons";
import { Box, Icon, IconButton } from "native-base";

export const LazyVideoPlayer: FC<{ mediaName: any, name?: string }> = ({ mediaName, name }) => {
    const [isLoaded, setIsLoaded] = React.useState(false);

    // Estado 1: Inactivo (No consume NADA de RAM ni de Hardware)
    if (!isLoaded) {
        return (
            <Pressable
                onPress={() => setIsLoaded(true)}
                style={{ width: "100%", height: 150, flex: 1, backgroundColor: "#1f2937", marginTop: 2, justifyContent: "center", alignItems: "center", borderRadius: 4, borderWidth: 1, borderColor: '#374151' }}
            >
                <Icon as={Ionicons} name="play-circle-outline" size="5xl" color="white" />
                <Text color="gray.300" fontSize="sm" mt={2}>{name}</Text>
            </Pressable>
        );
    }

    // Estado 2: Activo (Consume Hardware solo mientras se ve)
    return (
        <Box style={{ width: "100%", height: 150, flex: 1, marginTop: 2 }}>
            <Video
                source={mediaName}
                resizeMode={ResizeMode.CONTAIN}
                style={{ width: "100%", height: 150, flex: 1, backgroundColor: "#000" }}
                useNativeControls
                shouldPlay={true}
                onPlaybackStatusUpdate={(status) => {
                    // @ts-ignore
                    if (status.isLoaded) {
                        // ¡LA MAGIA! Si el video termina de reproducirse, 
                        // desmontamos el reproductor para liberar el hardware.
                        if (status.didJustFinish) {
                            setIsLoaded(false);
                        }
                    }
                }}
            />
            {/* Un pequeño botón X por si el usuario quiere cerrarlo antes de que termine */}
            <IconButton
                icon={<Icon as={Ionicons} name="close-circle" size="md" color="white" />}
                position="absolute"
                top={1}
                right={1}
                backgroundColor="rgba(0,0,0,0.5)"
                borderRadius="full"
                onPress={() => setIsLoaded(false)}
            />
        </Box>
    );
};